module.exports = __webpack_public_path__ + "img/les-echos-logo-svg-vector.658cc8f0.svg";